import Portal from "@arcgis/core/portal/Portal";
import PortalGroup from "@arcgis/core/portal/PortalGroup";
import esriConfig from "@arcgis/core/config";
import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import IdentityManager from "@arcgis/core/identity/IdentityManager";

export default {
    DASHBOARDS_GROUP_ID: '3a7b0b125aa941ba8775ce109fd48882',
    PORTAL_URL: 'https://gis.msu.edu/portal',

    name: 'PortalUtils',

    getDashboardItems: async function () {
        const appId =
            "XlsTWaHKeBeqDxMT"; /* https://gis.msu.edu/portal/home/item.html?id=376ae73cd9b546e0b1475802b715698a */

        esriConfig.portalUrl = this.PORTAL_URL;

        const info = new OAuthInfo({
            appId: appId,
            portalUrl: this.PORTAL_URL,
            popup: false,
        });
        const esriId = IdentityManager;
        esriId.registerOAuthInfos([info]);

        const portal = await new Portal({
            url: this.PORTAL_URL,
            authMode: "auto",
        }).load();

        const group = new PortalGroup({
            id: this.DASHBOARDS_GROUP_ID,
            portal: portal
        });

        const items = await group.queryItems({
            sortField: 'title',
            sortOrder: 'asc'
        })

        return items.results
    }
}
